/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

/**
 * @nullable
 */
export type CreateManagerRequestAvailability = typeof CreateManagerRequestAvailability[keyof typeof CreateManagerRequestAvailability] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateManagerRequestAvailability = {
  checked_in: 'checked_in',
  checked_out: 'checked_out',
} as const;
